import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import BoxContainer from '../../style-components/BoxContainer.jsx';
import HeaderContainer from '../../style-components/HeaderContainer.jsx';
import LearnunitQuestionsTable from '../../style-components/Tables/LearnunitQuestionTable.jsx';
import Loading from '../../style-components/Loading.jsx';
import { useGetQuestions, useGetQuestionByEvaluation } from '../../models/questions.js';
import { useGetEvaluation } from '../../models/evaluations.js';
import { useGetCourseLearningUnits } from '../../models/learnunits.js';

function LearnunitQuestions() {
  const { id, unit_id, eval_id } = useParams();

  const [questions, setQuestions] = useState([]);
  const [typeFilter, setTypeFilter] = useState('');
  const [searchFilter, setSearchFilter] = useState('');
  const [selectedLearnunits, setSelectedLearnunits] = useState([unit_id]); // Multi-select state

  // Get all learning units for the course
  const [learnunitsData, learnunitsDataLoading] = useGetCourseLearningUnits(id);

  // Convert selected learnunits array to comma-separated string for API
  const learnunitFilter = selectedLearnunits.length > 0 ? selectedLearnunits.join(',') : '';

  const [questionsData, questionsDataLoading] = useGetQuestions(
    1,
    9999999, // FIXME
    learnunitFilter,
    typeFilter,
    searchFilter
  );
  const [questionsByEvaluationData, questionsByEvaluationDataLoading] =
    useGetQuestionByEvaluation(eval_id);
  const [evaluation] = useGetEvaluation(eval_id);

  const actions = [{}];
  const itemsBreadcrumb = {
    items: [
      { name: 'Cursos', href: '/courses' },
      {
        name: 'Unidades de Aprendizaje',
        href: `/courses/${id}/learning_units`,
      },
      {
        name: 'Evaluaciones',
        href: `/courses/${id}/${unit_id}/evaluations`,
      },
      {
        name: 'Preguntas',
        href: `/courses/${id}/${unit_id}/evaluations/${eval_id}/question`,
      },
      {
        name: `Añadir preguntas a la evaluación ${evaluation?.name}`,
        href: '',
      },
    ],
    maxItems: 5,
  };

  useEffect(() => {
    if (
      questionsData &&
      !questionsDataLoading &&
      questionsByEvaluationData &&
      !questionsByEvaluationDataLoading
    ) {
      const questionsInEvaluationDict = {};
      questionsByEvaluationData.forEach(question => {
        questionsInEvaluationDict[question.id] = true;
      });
      const questionsInUnit = questionsData.questions.filter(
        question => !questionsInEvaluationDict[question.id]
      );
      setQuestions(questionsInUnit);
    }
  }, [
    questionsData,
    questionsDataLoading,
    questionsByEvaluationData,
    questionsByEvaluationDataLoading,
  ]);

  return (
    <BoxContainer>
      <div className='antialiased font-sans w-full'>
        <div className='divide-y divide-primary'>
          <HeaderContainer breadcrumb={itemsBreadcrumb} actions={actions} />
          {questionsDataLoading ? (
            <Loading />
          ) : (
            <LearnunitQuestionsTable
              questions={questions}
              typeFilter={typeFilter}
              setTypeFilter={setTypeFilter}
              searchFilter={searchFilter}
              setSearchFilter={setSearchFilter}
              selectedLearnunits={selectedLearnunits}
              setSelectedLearnunits={setSelectedLearnunits}
              learnunitsData={learnunitsData}
              learnunitsDataLoading={learnunitsDataLoading}
              currentUnitId={unit_id}
            />
          )}
        </div>
      </div>
    </BoxContainer>
  );
}

export default LearnunitQuestions;
